import { Badge } from "@/components/ui/badge";
import { daysUntil, formatDate } from "../../../shared/format";

interface Props {
  validUntil: string | null | undefined;
  expired?: boolean;
}

/** Coloured pill summarising a license's expiry status. */
export function LicenseBadge({ validUntil, expired }: Props) {
  if (!validUntil) {
    return (
      <Badge variant="muted" className="gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
        Không có hạn
      </Badge>
    );
  }
  if (expired) {
    return (
      <Badge variant="destructive" className="gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
        Hết hạn từ {formatDate(validUntil)}
      </Badge>
    );
  }
  const days = daysUntil(validUntil);
  if (days == null) {
    return (
      <Badge variant="muted" className="gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
        —
      </Badge>
    );
  }
  if (days < 0) {
    return (
      <Badge variant="destructive" className="gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
        Hết hạn từ {formatDate(validUntil)}
      </Badge>
    );
  }
  if (days <= 60) {
    return (
      <Badge variant="warning" className="gap-1.5" title={`Hết hạn ${formatDate(validUntil)}`}>
        <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
        Còn {days} ngày
      </Badge>
    );
  }
  return (
    <Badge variant="success" className="gap-1.5" title={`Hết hạn ${formatDate(validUntil)}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      Còn hiệu lực
    </Badge>
  );
}
